/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : NonMSAHardwareOptions.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H422336
*
* @Date         : Sep 10, 2020
*
* @Version      : Version 1.0
*
* By           : H422336
* On           : Sep 10, 2020
* Description  : ASDS-2741 Phase II Enhancements
*
* By             : H422336
* On             : Sep 14,2020
* Description    : ASDS-3037 UI Enhancements Phase-II
*
* By             : H422335
* On             : Sep 29,2020
* Description    : ASDS-3226 Non-MSA Purchase type selection page
*
* By             : H422335
* On             : Oct 27,2020
* Description    : ASDS-3269 ASDS-3269 Migration of backend URLs to Forge endpoints
*
* By            : H422337
* On            : 29 Oct 2020
* Description   : ASDS-3834 Highlight selected Non-MSA Purchase type 131-9 APU
*
* By             : H422335
* On             : Oct 27,2020
* Description    : ASDS-3269 ASDS-3269 Migration of backend URLs to Forge endpoints
******************************************************************************/
import * as React from 'react';
import '@scuf/common/honeywell/theme.css';
import { connect } from 'react-redux';
import './ConfigureAPU.css';
import { Card, Button, Grid } from '@scuf/common';
import CheckoutConstants from '../constants/checkout-constants';
import ConfigureAPUActions from '../redux/actions/configure-apu-actions';

interface IHardwareOptionsProps {
    isAdminUser: boolean;
    saveCustomerOrderType: any;
    productData: any;
}

interface IHardwareOptionStates {
    customerOrderType
}
interface IHWOptions {
    name: string;
    desc: string;
    visibility: boolean;
    selected: boolean;
}

class NonMSAHardwareOptions extends React.Component<IHardwareOptionsProps, IHardwareOptionStates>{
    constructor(props) {
        super(props);
        this.state = {
           customerOrderType : ''
        }
        this.handleSelectionType = this.handleSelectionType.bind(this);
    }

    setHardwareOptions = () => {
        let optionCards;
        const optionsText: Array<IHWOptions> = [{
            name: CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_SO,
            desc: `Free of charge key due to purchase of SB-131-49-8313 at Honeywell MRO. Requires SO of purchase.`,
            visibility: this.props.isAdminUser,
            selected: CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_SO === (this.props.productData.customerOrderType  !== '' ? this.props.productData.customerOrderType :this.state.customerOrderType) //   this.props.productData.customerOrderType
        }, {
            name: CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_PO,
            desc: `Free of charge due to purchase of new part number 70721640-2. Requires PO of purchase.`,
            visibility: true,
            selected: CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_PO === (this.props.productData.customerOrderType  !== '' ? this.props.productData.customerOrderType :this.state.customerOrderType)
        }, {
            name: CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_KEY_ONLY,
            desc: `APU does not need new hardware. Customer will obtain key through direct purchase.`,
            visibility: true,
            selected: CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_KEY_ONLY === (this.props.productData.customerOrderType  !== '' ? this.props.productData.customerOrderType :this.state.customerOrderType)
        }];
         const visibilityOptions =  optionsText?.filter(options => options?.visibility);

        optionCards = optionsText.map((type, index) => {
            if (type.visibility) {
                return (
                    <Grid.Column width={this.props.isAdminUser ? 4 : 6} xsWidth={12} key={'type-' + index} className="card-options-wrapper">
                        <Card className= {visibilityOptions?.length === 3 ? "card-option-3" : "card-option-2"}>
                            <Card.Content>
                                <div className="card-option-heading">{type.name}</div>
                                <p className="card-option-desc">
                                    {type.desc}
                                </p>

                            </Card.Content>
                            <Card.Footer>
                            <Button
                                    type={type.selected ? 'primary' : 'secondary' }
                                    content={type.selected ? 'SELECTED' : 'SELECT' }
                                    size="small"
                                    className="card-option-button co-secondary-button"
                                    onClick={() => this.handleSelectionType(type.name)}
                                />

                            </Card.Footer>
                        </Card>
                    </Grid.Column>
                );
            } else {
                return '';
            }
        });
        return optionCards;
    }

    handleSelectionType(option) {
        this.props.saveCustomerOrderType(option, '');
                this.setState({customerOrderType:option});

    }

    render() {
        let options = this.setHardwareOptions();

        return (
            <div className="hardware-options-panel">
                <Grid>
                    <Grid.Row>
                        {options}
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

const mapDispatchToProps = {
    saveCustomerOrderType: ConfigureAPUActions.saveCustomerOrderType
};

function mapStateToProps(state: any) {
    return {
        isAdminUser: state.userValidationData.payload.isAdminUser,
        productData: state.configAPUData.payload
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NonMSAHardwareOptions);